'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMortarBoard = function TiMortarBoard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.2 13.2s-9.7-4.9-11.5-5.9-2.9-1.1-5 0c-2.2 1-11.2 5.5-11.2 5.5-1.3 0.7-2.5 2-2.5 3.4s0.3 2 0.3 2l-0.5 2.5c-0.5 2-0.5 4.5-0.5 5.5 0 2.5 2.2 4.3 3.7 4.5 1.5 0.1 2.7-0.2 2.7-0.2 2.3 2.2 6.1 3.5 10.6 3.5 7.4 0 13-3.7 13-8.3 0-1.9-0.6-4.5-0.6-4.5l1.8-1c1.5-0.9 2.2-2.4 2.2-3.9-0.2-1.3-1-2.5-2.5-3.1z m-13.7 17.3c-5.3 0-9.7-2.2-9.7-5l0.9-4.7 7 3.5c1 0.5 2.5 0.5 3.6 0l7.2-3.5 0.7 4.7c0 2.7-4.2 5-9.7 5z m12.2-13.5l-11 5.7c-0.7 0.3-1.7 0.3-2.4 0l-9.5-4.9c-0.3 0.9-0.5 2-0.5 3.4 0 2.3 0.4 4 0.4 4.8s-0.5 1.3-1.2 1.3h-0.2c-0.6 0-1.3-0.5-1.3-1.3s0-2.7 0.5-5.2c0.3-1.5 0.7-2.8 1-3.6l-0.3-0.2c-0.7-0.3-0.7-0.8 0-1.2l11.1-5.6c0.7-0.4 1.5-0.4 2.2 0s11.2 5.6 11.2 5.6c0.6 0.4 0.6 0.9 0 1.2z' })
        )
    );
};

exports.default = TiMortarBoard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/mortar-board.js
// module id = 3703
// module chunks = 0